export default __webpack_public_path__ + "static/media/MazePolitics_120_Perc.2d08c654.mp3";